var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskboardUrl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10L10 6",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 3.99998L7.64216 3.64265C8.26737 3.01753 9.11529 2.66638 9.9994 2.66644C10.8835 2.66651 11.7314 3.01778 12.3565 3.64298C12.9816 4.26818 13.3328 5.11611 13.3327 6.00022C13.3326 6.88432 12.9814 7.7322 12.3562 8.35731L12.0002 8.66665",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6666 12L8.40193 12.356C7.76943 12.9814 6.91579 13.3322 6.02627 13.3322C5.13674 13.3322 4.2831 12.9814 3.6506 12.356C3.33884 12.0477 3.09133 11.6807 2.92241 11.2761C2.75348 10.8715 2.6665 10.4374 2.6665 9.99898C2.6665 9.56055 2.75348 9.12647 2.92241 8.72188C3.09133 8.3173 3.33884 7.95025 3.6506 7.64198L3.99993 7.33331",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskboardUrl);
export default __webpack_public_path__ + "static/media/taskboard_url.be179829a7096a993785b2db7fe68387.svg";
export { ForwardRef as ReactComponent };